// import React, { useState, useEffect, useRef } from "react";
import { AdditionalPhones, withCountryCode } from "../utils/phones";
// import { Link } from "react-router-dom";
// import { API_BASE_URL } from "../../config";
// import axios from "axios";
// import Pagination from "@mui/material/Pagination";
// import { toast } from "react-toastify";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import moment from "moment";
// import TableLoader from "../../Loader/TableLoader";
// import Swal from "sweetalert2";
// import EnquiryModal from "./enquiryModal";

// import { Button, Input, Tooltip } from "antd";
// import {
//   FilterOutlined,
//   ClearOutlined,
//   SearchOutlined,
//   CalendarOutlined,
//   EyeOutlined,
//   DeleteOutlined,
//   CloseCircleOutlined,
//   ArrowRightOutlined,
// } from "@ant-design/icons";
// import { useUpdateEnquiryStatus } from "../hooks/useManageEnquiry";
// import { useFollowUpOptions } from "../hooks/useManageEnquiry";

// const CustomDateInput = React.forwardRef(
//   ({ value, onClick, placeholder }, ref) => (
//     <div
//       onClick={onClick}
//       ref={ref}
//       style={{
//         display: "flex",
//         alignItems: "center",
//         gap: "8px",
//         padding: "8px 12px",
//         border: "1px solid #e0e0e0",
//         borderRadius: "8px",
//         cursor: "pointer",
//         minHeight: "42px",
//         background: "white",
//         transition: "all 0.2s",
//         width: "100%",
//         fontSize: "14px",
//         color: value ? "#262626" : "#bfbfbf",
//       }}
//     >
//       <CalendarOutlined
//         style={{ color: "#dc2626", fontSize: "14px", flexShrink: 0 }}
//       />
//       <span style={{ flex: 1 }}>{value || placeholder}</span>
//     </div>
//   ),
// );

// const EMPTY_FILTER = { search: "", start_date: "", end_date: "" };

// const NegativeEnquiry = () => {
//   const [listPageData, setListPageData] = useState([]);
//   const [token] = useState(localStorage.getItem("cms_token"));
//   const [isLoading, setIsLoading] = useState(true);
//   const [modalIsOpen2, setIsOpen2] = useState(false);
//   const [statusId, setStatusId] = useState(0);
//   const [statusCode, setStatusCode] = useState(0);
//   const [modalStatus, setModalStatus] = useState(false);
//   const [pageSize, setPageSize] = useState(1);
//   const [pageApi, setPageApi] = useState(1);
//   const [totalUser, setTotalUser] = useState(0);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [isDeleteAll, setIsDeleteAll] = useState([]);
//   const [isDeleted, setDeleted] = useState(false);
//   const [selectAll, setSelectAll] = useState(false);
//   const [filterForm, setFilterForm] = useState(EMPTY_FILTER);
//   const [appliedFilter, setAppliedFilter] = useState(EMPTY_FILTER);
//   const [isFilterLoading, setIsFilterLoading] = useState(false);
//   const [showCheckboxes, setShowCheckboxes] = useState(false);
//   const updateStatus = useUpdateEnquiryStatus();
//   const searchDebounceRef = useRef(null);
//   const { data: followUpOptions = [] } = useFollowUpOptions();

//   const followUpStatusMap = React.useMemo(() => {
//     const map = {};
//     followUpOptions.forEach((opt) => {
//       map[String(opt.option_value)] = opt.label;
//     });
//     return map;
//   }, [followUpOptions]);

//   useEffect(() => {
//     loadContent();
//   }, [pageApi, isDeleted, modalStatus, appliedFilter]);

//   const loadContent = async () => {
//     setIsLoading(true);
//     let param = {
//       search: appliedFilter.search,
//       start_date: startDate
//         ? moment(startDate).utc().add(1, "d").format("YYYY-MM-DD")
//         : "",
//       end_date: endDate
//         ? moment(endDate).utc().add(1, "d").format("YYYY-MM-DD")
//         : "",
//       status: 10, // Negative = option_value 10
//       page: pageApi,
//       limit: 10,
//     };
//     try {
//       const response = await axios.get(
//         `${API_BASE_URL}/get-trademark-enquiries`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           params: param,
//         },
//       );

//       const allData = response.data.data || [];

//       // Client-side filter until backend supports status param
//       const negativeData = allData.filter(
//         (item) => String(item.status) === "10",
//       );

//       setListPageData(negativeData);
//       setTotalUser(negativeData.length);
//       setPageSize(Math.ceil(negativeData.length / 10));
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setIsLoading(false);
//       setIsFilterLoading(false);
//     }
//   };

//   const followUpStatusStyle = (label) => {
//     const l = (label || "").toLowerCase();
//     if (l === "follow up")
//       return { bg: "#fffbeb", color: "#d97706", border: "#fde68a" };
//     if (l === "hot lead")
//       return { bg: "#fff7ed", color: "#ea580c", border: "#fed7aa" };
//     if (l === "no response")
//       return { bg: "#f9fafb", color: "#6b7280", border: "#e5e7eb" };
//     if (l === "interested")
//       return { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0" };
//     if (l === "mark for future")
//       return { bg: "#fefce8", color: "#ca8a04", border: "#fef08a" };
//     if (l === "not interested")
//       return { bg: "#fef2f2", color: "#b91c1c", border: "#fecaca" };
//     if (l === "meeting scheduled")
//       return { bg: "#eff6ff", color: "#2563eb", border: "#bfdbfe" };
//     if (l === "converted")
//       return { bg: "#f0fdf4", color: "#16a34a", border: "#bbf7d0" };
//     if (l === "not responding")
//       return { bg: "#f5f5f5", color: "#9ca3af", border: "#e5e7eb" };
//     if (l === "closed")
//       return { bg: "#f5f3ff", color: "#7c3aed", border: "#ddd6fe" };
//     if (l === "negative")
//       return { bg: "#fef2f2", color: "#dc2626", border: "#fecaca" };
//     return { bg: "#f9fafb", color: "#6b7280", border: "#e5e7eb" };
//   };

//   const handleMoveToFollowUp = (id) => {
//     Swal.fire({
//       title: "Move back to Follow Up?",
//       input: "textarea",
//       inputLabel: "Remark",
//       inputPlaceholder: "Enter your remark...",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Move to Follow Up",
//       confirmButtonColor: "#16a34a",
//     }).then((r) => {
//       if (r.isConfirmed)
//         updateStatus.mutate(
//           { id, status: 0, remarks: r.value || "" },
//           { onSuccess: () => setDeleted((p) => !p) },
//         );
//     });
//   };

//   const handleNegative = (id) => {
//     Swal.fire({
//       title: "Mark as Negative?",
//       input: "textarea",
//       inputLabel: "Remark",
//       inputPlaceholder: "Enter your remark...",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Mark Negative",
//       confirmButtonColor: "#dc2626",
//     }).then((r) => {
//       if (r.isConfirmed)
//         updateStatus.mutate(
//           { id, status: 2, remarks: r.value || "" },
//           { onSuccess: () => setDeleted((p) => !p) },
//         );
//     });
//   };

//   const handleDelete = async (ids) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Do you want to delete the record?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Delete",
//       cancelButtonText: "Cancel",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const response = await axios.post(
//             `${API_BASE_URL}/delete-my-trademark-enquiry`,
//             JSON.stringify({ id: [ids] }),
//             {
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//               },
//             },
//           );
//           if (response.data.status === 200) {
//             Swal.fire("Deleted!", "Your file has been deleted.", "success");
//             setDeleted((p) => !p);
//           }
//         } catch {
//           Swal.fire("Error", "Failed to delete the file.", "error");
//         }
//       }
//     });
//   };

//   const showAlertDelete = async () => {
//     if (isDeleteAll.length === 0) {
//       Swal.fire({
//         icon: "error",
//         title: "No leads selected",
//         text: "Please select at least one lead to delete.",
//       });
//       return;
//     }
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Delete ${isDeleteAll.length} selected lead(s)?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Delete",
//       cancelButtonText: "Cancel",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const response = await axios.post(
//             `${API_BASE_URL}/delete-my-trademark-enquiry`,
//             JSON.stringify({ id: isDeleteAll }),
//             {
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//               },
//             },
//           );
//           if (response.data.status === 200) {
//             Swal.fire("Deleted!", "Selected leads deleted.", "success");
//             setDeleted((p) => !p);
//             setIsDeleteAll([]);
//             setSelectAll(false);
//           }
//         } catch {
//           Swal.fire("Error", "Failed to delete.", "error");
//         }
//       } else {
//         Swal.fire("Cancelled", "Your records are safe.", "info");
//       }
//     });
//   };

//   const handleSearchChange = (e) => {
//     const v = e.target.value;
//     setFilterForm((p) => ({ ...p, search: v }));
//     if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
//     searchDebounceRef.current = setTimeout(() => {
//       setPageApi(1);
//       setAppliedFilter((p) => ({ ...p, search: v }));
//     }, 500);
//   };

//   const applyFilter = () => {
//     setPageApi(1);
//     setIsFilterLoading(true);
//     setAppliedFilter({ ...filterForm });
//     loadContent();
//   };

//   const clearFilter = () => {
//     setFilterForm(EMPTY_FILTER);
//     setStartDate("");
//     setEndDate("");
//     setAppliedFilter(EMPTY_FILTER);
//     setPageApi(1);
//   };

//   const handleCheckAll = () => {
//     const n = !selectAll;
//     setSelectAll(n);
//     setIsDeleteAll(n ? listPageData.map((i) => i.id) : []);
//   };

//   const handleCheckboxChange = (item) => {
//     setIsDeleteAll((p) =>
//       p.includes(item.id) ? p.filter((id) => id !== item.id) : [...p, item.id],
//     );
//   };

//   const activeFiltersCount = [filterForm.search, startDate, endDate].filter(
//     Boolean,
//   ).length;

//   const labelStyle = {
//     fontWeight: 600,
//     color: "#374151",
//     fontSize: "13px",
//     marginBottom: "6px",
//     display: "flex",
//     alignItems: "center",
//     gap: "5px",
//   };

//   const statusBadge = (val) => {
//     if (val == 1)
//       return {
//         bg: "#f0fdf4",
//         color: "#16a34a",
//         border: "#bbf7d0",
//         label: "● Positive",
//       };
//     if (val == 2)
//       return {
//         bg: "#fef2f2",
//         color: "#dc2626",
//         border: "#fecaca",
//         label: "● Negative",
//       };
//     if (val == 0)
//       return {
//         bg: "#eff6ff",
//         color: "#2563eb",
//         border: "#bfdbfe",
//         label: "● Neutral",
//       };
//     return {
//       bg: "#fffbeb",
//       color: "#d97706",
//       border: "#fde68a",
//       label: "● Pending",
//     };
//   };

//   return (
//     <>
//       <style>{`
//         .custom-datepicker-wrapper{width:100%}.custom-datepicker-wrapper .react-datepicker-wrapper{width:100%}.custom-datepicker-wrapper .react-datepicker__input-container{width:100%}.custom-datepicker-wrapper .react-datepicker-popper{z-index:9999!important}.custom-datepicker-wrapper .react-datepicker{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;border:1px solid #fecaca;border-radius:12px;box-shadow:0 8px 24px rgba(220,38,38,.15);overflow:hidden;font-size:13px}.custom-datepicker-wrapper .react-datepicker__month-container{width:280px}.custom-datepicker-wrapper .react-datepicker__header{background:linear-gradient(135deg,#dc2626 0%,#b91c1c 100%);border-bottom:none;padding:10px 8px 6px;border-radius:0}.custom-datepicker-wrapper .react-datepicker__current-month{color:#fff;font-weight:700;font-size:14px;margin-bottom:4px}.custom-datepicker-wrapper .react-datepicker__day-names{display:flex;justify-content:space-around}.custom-datepicker-wrapper .react-datepicker__day-name{color:rgba(255,255,255,.85);font-weight:600;font-size:11px;width:32px;line-height:32px;margin:1px;text-align:center}.custom-datepicker-wrapper .react-datepicker__month{margin:6px}.custom-datepicker-wrapper .react-datepicker__week{display:flex;justify-content:space-around}.custom-datepicker-wrapper .react-datepicker__day{width:32px;line-height:32px;margin:1px;border-radius:6px;font-size:13px;color:#374151;transition:all .15s;text-align:center}.custom-datepicker-wrapper .react-datepicker__day:hover{background:#fef2f2;color:#dc2626}.custom-datepicker-wrapper .react-datepicker__day--selected,.custom-datepicker-wrapper .react-datepicker__day--keyboard-selected{background:linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)!important;color:#fff!important;font-weight:600}.custom-datepicker-wrapper .react-datepicker__day--today{font-weight:700;color:#dc2626}.custom-datepicker-wrapper .react-datepicker__day--disabled{color:#d1d5db!important}.custom-datepicker-wrapper .react-datepicker__day--outside-month{color:#d1d5db}.custom-datepicker-wrapper .react-datepicker__navigation{top:10px}.custom-datepicker-wrapper .react-datepicker__navigation-icon::before{border-color:rgba(255,255,255,.8);border-width:2px 2px 0 0;height:7px;width:7px}.custom-datepicker-wrapper .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before{border-color:#fff}.custom-datepicker-wrapper .react-datepicker__triangle{display:none}
//         @keyframes badgePop{0%{transform:scale(1)}50%{transform:scale(1.2)}100%{transform:scale(1)}}
//         .sel-badge{animation:badgePop .25s ease}
//       `}</style>

//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             {/* PAGE HEADER */}
//             <div
//               style={{
//                 background: "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)",
//                 borderRadius: "16px",
//                 padding: "28px 32px",
//                 marginBottom: "28px",
//                 boxShadow: "0 8px 32px rgba(220,38,38,.28)",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 flexWrap: "wrap",
//                 gap: "16px",
//               }}
//             >
//               <div
//                 style={{ display: "flex", alignItems: "center", gap: "16px" }}
//               >
//                 <div
//                   style={{
//                     width: "56px",
//                     height: "56px",
//                     background: "rgba(255,255,255,.22)",
//                     borderRadius: "14px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: "26px",
//                     color: "white",
//                   }}
//                 >
//                   <CloseCircleOutlined />
//                 </div>
//                 <div>
//                   <h4
//                     style={{
//                       color: "white",
//                       margin: 0,
//                       fontSize: "24px",
//                       fontWeight: 700,
//                     }}
//                   >
//                     Manage Negative Lead
//                   </h4>
//                   <p
//                     style={{
//                       color: "rgba(255,255,255,.85)",
//                       margin: 0,
//                       fontSize: "14px",
//                     }}
//                   >
//                     View and manage all negative lead records
//                   </p>
//                 </div>
//               </div>
//               <div
//                 style={{
//                   background: "rgba(255,255,255,.18)",
//                   padding: "10px 18px",
//                   borderRadius: "10px",
//                   display: "flex",
//                   gap: "6px",
//                   alignItems: "center",
//                   fontSize: "13px",
//                   color: "white",
//                 }}
//               >
//                 <a
//                   href="javascript:void(0);"
//                   style={{ color: "white", textDecoration: "none" }}
//                 >
//                   CMS
//                 </a>
//                 <span style={{ color: "rgba(255,255,255,.5)" }}>›</span>
//                 <span style={{ fontWeight: 600 }}>Manage Negative Lead</span>
//               </div>
//             </div>

//             {/* FILTER CARD */}
//             <div
//               style={{
//                 background: "white",
//                 borderRadius: "16px",
//                 boxShadow: "0 2px 16px rgba(0,0,0,.07)",
//                 border: "1px solid #f0f0f0",
//                 marginBottom: "24px",
//                 overflow: "visible",
//               }}
//             >
//               <div
//                 style={{
//                   background: "linear-gradient(135deg,#fff5f5 0%,#fee2e2 100%)",
//                   borderBottom: "2px solid #fecaca",
//                   padding: "18px 24px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <div
//                     style={{
//                       width: "38px",
//                       height: "38px",
//                       background:
//                         "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)",
//                       borderRadius: "10px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       color: "white",
//                       fontSize: "16px",
//                     }}
//                   >
//                     <FilterOutlined />
//                   </div>
//                   <div>
//                     <div
//                       style={{
//                         fontWeight: 700,
//                         fontSize: "16px",
//                         color: "#1f2937",
//                       }}
//                     >
//                       Advanced Filters
//                     </div>
//                     <div style={{ fontSize: "12px", color: "#6b7280" }}>
//                       Narrow down your negative lead search
//                     </div>
//                   </div>
//                 </div>
//                 {activeFiltersCount > 0 && (
//                   <span
//                     style={{
//                       background: "linear-gradient(135deg,#dc2626,#b91c1c)",
//                       color: "white",
//                       borderRadius: "20px",
//                       padding: "4px 14px",
//                       fontSize: "13px",
//                       fontWeight: 600,
//                     }}
//                   >
//                     {activeFiltersCount} active
//                   </span>
//                 )}
//               </div>
//               <div style={{ padding: "24px" }}>
//                 <div className="row g-3">
//                   <div className="col-md-4">
//                     <div style={labelStyle}>
//                       <SearchOutlined style={{ color: "#dc2626" }} /> Name,
//                       Email or Mobile
//                     </div>
//                     <Input
//                       size="large"
//                       placeholder="Search by name, email or mobile..."
//                       value={filterForm.search}
//                       onChange={handleSearchChange}
//                       prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
//                       style={{ borderRadius: "8px" }}
//                       allowClear
//                     />
//                   </div>
//                   <div className="col-md-4">
//                     <div style={labelStyle}>
//                       <CalendarOutlined style={{ color: "#dc2626" }} /> Start
//                       Date
//                     </div>
//                     <div className="custom-datepicker-wrapper">
//                       <DatePicker
//                         selected={startDate}
//                         onChange={(d) => setStartDate(d)}
//                         selectsStart
//                         startDate={startDate}
//                         endDate={endDate}
//                         dateFormat="dd MMM yyyy"
//                         placeholderText="Select start date"
//                         isClearable={!!startDate}
//                         customInput={
//                           <CustomDateInput placeholder="Select start date" />
//                         }
//                         popperPlacement="bottom-start"
//                         popperModifiers={[
//                           {
//                             name: "preventOverflow",
//                             options: { boundary: "viewport" },
//                           },
//                           { name: "offset", options: { offset: [0, 4] } },
//                         ]}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div style={labelStyle}>
//                       <CalendarOutlined style={{ color: "#dc2626" }} /> End Date
//                     </div>
//                     <div className="custom-datepicker-wrapper">
//                       <DatePicker
//                         selected={endDate}
//                         onChange={(d) => setEndDate(d)}
//                         selectsEnd
//                         startDate={startDate}
//                         endDate={endDate}
//                         minDate={startDate}
//                         dateFormat="dd MMM yyyy"
//                         placeholderText="Select end date"
//                         isClearable={!!endDate}
//                         customInput={
//                           <CustomDateInput placeholder="Select end date" />
//                         }
//                         popperPlacement="bottom-start"
//                         popperModifiers={[
//                           {
//                             name: "preventOverflow",
//                             options: { boundary: "viewport" },
//                           },
//                           { name: "offset", options: { offset: [0, 4] } },
//                         ]}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginTop: "20px",
//                     paddingTop: "20px",
//                     borderTop: "1px solid #f0f0f0",
//                   }}
//                 >
//                   <Button
//                     size="large"
//                     icon={<ClearOutlined />}
//                     onClick={clearFilter}
//                     style={{
//                       borderRadius: "10px",
//                       minWidth: "130px",
//                       fontWeight: 600,
//                       borderColor: "#dc2626",
//                       color: "#dc2626",
//                       height: "44px",
//                     }}
//                   >
//                     Clear Filters
//                   </Button>
//                   <Button
//                     type="primary"
//                     size="large"
//                     icon={<FilterOutlined />}
//                     onClick={applyFilter}
//                     loading={isFilterLoading}
//                     style={{
//                       borderRadius: "10px",
//                       minWidth: "130px",
//                       fontWeight: 600,
//                       height: "44px",
//                       background:
//                         "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)",
//                       border: "none",
//                       boxShadow: "0 4px 12px rgba(220,38,38,.4)",
//                     }}
//                   >
//                     Apply Filters
//                   </Button>
//                 </div>
//               </div>
//             </div>

//             <EnquiryModal
//               token={token}
//               modalIsOpen2={modalIsOpen2}
//               setIsOpen2={setIsOpen2}
//               id={statusId}
//               setStatusId={setStatusId}
//               statusCode={statusCode}
//               setStatusCode={setStatusCode}
//               setModalStatus={setModalStatus}
//               modalStatus={modalStatus}
//             />

//             {/* TABLE CARD */}
//             <div
//               style={{
//                 background: "white",
//                 borderRadius: "16px",
//                 boxShadow: "0 2px 16px rgba(0,0,0,.07)",
//                 border: "1px solid #f0f0f0",
//                 overflow: "hidden",
//               }}
//             >
//               {/* Action bar */}
//               <div
//                 style={{
//                   padding: "20px 24px",
//                   borderBottom: "2px solid #f5f5f5",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   flexWrap: "wrap",
//                   gap: "12px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <div
//                     style={{
//                       width: "38px",
//                       height: "38px",
//                       background:
//                         "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)",
//                       borderRadius: "10px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       color: "white",
//                       fontSize: "16px",
//                     }}
//                   >
//                     <CloseCircleOutlined />
//                   </div>
//                   <div>
//                     <div
//                       style={{
//                         fontWeight: 700,
//                         fontSize: "17px",
//                         color: "#1f2937",
//                       }}
//                     >
//                       Negative Lead List
//                     </div>
//                     <div style={{ fontSize: "12px", color: "#6b7280" }}>
//                       {totalUser} total {totalUser === 1 ? "record" : "records"}
//                     </div>
//                   </div>
//                   <span
//                     style={{
//                       background: "#fef2f2",
//                       color: "#dc2626",
//                       borderRadius: "20px",
//                       padding: "3px 12px",
//                       fontSize: "13px",
//                       fontWeight: 700,
//                     }}
//                   >
//                     {totalUser}
//                   </span>
//                   {isDeleteAll.length > 0 && (
//                     <span
//                       key={isDeleteAll.length}
//                       className="sel-badge"
//                       style={{
//                         background: "linear-gradient(135deg,#ef4444,#dc2626)",
//                         color: "white",
//                         borderRadius: "20px",
//                         padding: "3px 12px",
//                         fontSize: "13px",
//                         fontWeight: 700,
//                       }}
//                     >
//                       {isDeleteAll.length} selected
//                     </span>
//                   )}
//                 </div>
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "10px",
//                     alignItems: "center",
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   {showCheckboxes && (
//                     <button
//                       onClick={() => {
//                         setShowCheckboxes(false);
//                         setIsDeleteAll([]);
//                         setSelectAll(false);
//                       }}
//                       style={{
//                         display: "inline-flex",
//                         alignItems: "center",
//                         gap: "6px",
//                         background: "white",
//                         color: "#6b7280",
//                         borderRadius: "10px",
//                         padding: "8px 18px",
//                         fontWeight: 600,
//                         fontSize: "14px",
//                         border: "2px solid #e0e0e0",
//                         cursor: "pointer",
//                       }}
//                     >
//                       ✕ Cancel
//                     </button>
//                   )}

//                   <button
//                     onClick={() => {
//                       if (!showCheckboxes) {
//                         setShowCheckboxes(true);
//                         setIsDeleteAll([]);
//                         setSelectAll(false);
//                         return;
//                       }
//                       showAlertDelete();
//                     }}
//                     style={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       gap: "6px",
//                       background:
//                         "linear-gradient(135deg,#ef4444 0%,#dc2626 100%)",
//                       color: "white",
//                       borderRadius: "10px",
//                       padding: "8px 18px",
//                       fontWeight: 600,
//                       fontSize: "14px",
//                       border: "none",
//                       cursor: "pointer",
//                       boxShadow: "0 4px 12px rgba(239,68,68,.3)",
//                       transition: "all 0.2s",
//                     }}
//                   >
//                     <DeleteOutlined /> Delete Selected
//                   </button>
//                 </div>
//               </div>

//               {/* Table */}
//               <div className="table-responsive">
//                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                   <thead>
//                     <tr
//                       style={{
//                         background:
//                           "linear-gradient(135deg,#fff5f5 0%,#fee2e2 100%)",
//                         borderBottom: "2px solid #fecaca",
//                       }}
//                     >
//                       {showCheckboxes && (
//                         <th
//                           style={{ padding: "14px 16px", textAlign: "center" }}
//                         >
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             checked={selectAll}
//                             onChange={handleCheckAll}
//                             style={{ accentColor: "#dc2626" }}
//                           />
//                         </th>
//                       )}
//                       {[
//                         "Name",
//                         "Email",
//                         "Mobile",
//                         "UTM Sources",
//                         "Sources",
//                         "Message",
//                         "Date",
//                         "Status",
//                         "Actions",
//                       ].map((h) => (
//                         <th
//                           key={h}
//                           style={{
//                             padding: "14px 16px",
//                             textAlign: "center",
//                             fontSize: "12px",
//                             fontWeight: 700,
//                             color: "#dc2626",
//                             textTransform: "uppercase",
//                             letterSpacing: "0.6px",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {h}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {isLoading ? (
//                       <TableLoader />
//                     ) : listPageData.length > 0 ? (
//                       listPageData.map((item, idx) => {
//                         const isSel = isDeleteAll.includes(item.id);
//                         return (
//                           <tr
//                             key={item.id}
//                             style={{
//                               borderBottom: "1px solid #f5f5f5",
//                               transition: "background 0.15s",
//                               background: isSel
//                                 ? "#fef2f2"
//                                 : idx % 2 === 0
//                                   ? "white"
//                                   : "#fffafa",
//                             }}
//                             onMouseEnter={(e) => {
//                               if (!isSel)
//                                 e.currentTarget.style.background = "#fff5f5";
//                             }}
//                             onMouseLeave={(e) => {
//                               if (!isSel)
//                                 e.currentTarget.style.background =
//                                   idx % 2 === 0 ? "white" : "#fffafa";
//                             }}
//                           >
//                             {showCheckboxes && (
//                               <td
//                                 style={{
//                                   padding: "14px 16px",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <input
//                                   type="checkbox"
//                                   checked={isSel}
//                                   onChange={() => handleCheckboxChange(item)}
//                                   style={{
//                                     accentColor: "#dc2626",
//                                     width: "15px",
//                                     height: "15px",
//                                   }}
//                                 />
//                               </td>
//                             )}
//                             {/* Name */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 textAlign: "left",
//                               }}
//                             >
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "10px",
//                                 }}
//                               >
//                                 <div
//                                   style={{
//                                     width: "34px",
//                                     height: "34px",
//                                     borderRadius: "50%",
//                                     background:
//                                       "linear-gradient(135deg,#dc2626,#b91c1c)",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     color: "white",
//                                     fontSize: "13px",
//                                     fontWeight: 700,
//                                     flexShrink: 0,
//                                   }}
//                                 >
//                                   {item.name
//                                     ?.split(" ")
//                                     .map((w) => w.charAt(0))
//                                     .join("")
//                                     .slice(0, 2)
//                                     .toUpperCase() || "?"}
//                                 </div>
//                                 <span
//                                   style={{
//                                     fontWeight: 600,
//                                     color: "#1f2937",
//                                     fontSize: "14px",
//                                   }}
//                                 >
//                                   {item?.name}
//                                 </span>
//                               </div>
//                             </td>
//                             {/* Email */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 fontSize: "13px",
//                                 color: "#4b5563",
//                               }}
//                             >
//                               {item?.email ? (
//                                 <span
//                                   style={{
//                                     background: "#eff6ff",
//                                     color: "#2563eb",
//                                     borderRadius: "4px",
//                                     padding: "2px 8px",
//                                     fontSize: "12px",
//                                     display: "inline-block",
//                                     wordBreak: "break-all",
//                                   }}
//                                 >
//                                   {item.email}
//                                 </span>
//                               ) : (
//                                 <span
//                                   style={{ color: "#9ca3af", fontSize: "12px" }}
//                                 >
//                                   N/A
//                                 </span>
//                               )}
//                             </td>
//                             {/* Mobile */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 fontSize: "13px",
//                                 color: "#4b5563",
//                                 whiteSpace: "nowrap",
//                               }}
//                             >
//                               {item?.phone ? (
//                                 <span
//                                   style={{ fontWeight: 500, color: "#374151" }}
//                                 >
//                                   {item.phone}
//                                 </span>
//                               ) : (
//                                 <span
//                                   style={{ color: "#9ca3af", fontSize: "12px" }}
//                                 >
//                                   N/A
//                                 </span>
//                               )}
//                             </td>
//                             {/* UTM */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 fontSize: "13px",
//                                 color: "#4b5563",
//                               }}
//                             >
//                               <div style={{ marginBottom: "2px" }}>
//                                 <span
//                                   style={{ color: "#9ca3af", fontSize: "12px" }}
//                                 >
//                                   Source:{" "}
//                                 </span>
//                                 {item?.utm_source || "N/A"}
//                               </div>
//                               <div style={{ marginBottom: "2px" }}>
//                                 <span
//                                   style={{ color: "#9ca3af", fontSize: "12px" }}
//                                 >
//                                   Medium:{" "}
//                                 </span>
//                                 {item?.utm_medium || "N/A"}
//                               </div>
//                               <div>
//                                 <span
//                                   style={{ color: "#9ca3af", fontSize: "12px" }}
//                                 >
//                                   Campaign:{" "}
//                                 </span>
//                                 {item?.utm_campaign
//                                   ? item.utm_campaign.substring(0, 10) + "..."
//                                   : "N/A"}
//                               </div>
//                             </td>
//                             {/* Sources */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 fontSize: "13px",
//                                 color: "#4b5563",
//                               }}
//                             >
//                               <div style={{ marginBottom: "2px" }}>
//                                 <span
//                                   style={{ color: "#9ca3af", fontSize: "12px" }}
//                                 >
//                                   IP:{" "}
//                                 </span>
//                                 {item.system_ip ? (
//                                   <a
//                                     href={`https://ip-api.com/#${item.system_ip}`}
//                                     target="_blank"
//                                     rel="noreferrer"
//                                     style={{ color: "#dc2626" }}
//                                   >
//                                     {item.system_ip}
//                                   </a>
//                                 ) : (
//                                   "N/A"
//                                 )}
//                               </div>
//                               <div>
//                                 <span
//                                   style={{ color: "#9ca3af", fontSize: "12px" }}
//                                 >
//                                   URL:{" "}
//                                 </span>
//                                 {item.source_url ? (
//                                   <a
//                                     href={item.source_url}
//                                     target="_blank"
//                                     rel="noreferrer"
//                                   >
//                                     <span
//                                       style={{
//                                         background: "#fef2f2",
//                                         color: "#dc2626",
//                                         borderRadius: "4px",
//                                         padding: "1px 6px",
//                                         fontSize: "12px",
//                                       }}
//                                     >
//                                       Click Here
//                                     </span>
//                                   </a>
//                                 ) : (
//                                   "N/A"
//                                 )}
//                               </div>
//                             </td>
//                             {/* Message */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 fontSize: "13px",
//                                 color: "#4b5563",
//                                 textAlign: "center",
//                               }}
//                             >
//                               {item.message
//                                 ? item.message.substring(0, 10) + "..."
//                                 : "N/A"}
//                             </td>
//                             {/* Date */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 fontSize: "13px",
//                                 color: "#4b5563",
//                                 whiteSpace: "nowrap",
//                                 textAlign: "center",
//                               }}
//                             >
//                               {item.created_date ||
//                                 moment(item.created_at).format("DD MMM YYYY")}
//                             </td>
//                             {/* Status */}
//                             {/* Status */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               {(() => {
//                                 const fuLabel =
//                                   item.status != null
//                                     ? followUpStatusMap[String(item.status)]
//                                     : null;

//                                 if (fuLabel) {
//                                   const style = followUpStatusStyle(fuLabel);
//                                   return (
//                                     <span
//                                       style={{
//                                         background: style.bg,
//                                         color: style.color,
//                                         border: `1px solid ${style.border}`,
//                                         borderRadius: "20px",
//                                         padding: "3px 12px",
//                                         fontSize: "12px",
//                                         fontWeight: 600,
//                                       }}
//                                     >
//                                       ● {fuLabel}
//                                     </span>
//                                   );
//                                 }

//                                 // Fallback to is_positive badge
//                                 const badge = statusBadge(item.is_positive);
//                                 return (
//                                   <span
//                                     style={{
//                                       background: badge.bg,
//                                       color: badge.color,
//                                       border: `1px solid ${badge.border}`,
//                                       borderRadius: "20px",
//                                       padding: "3px 12px",
//                                       fontSize: "12px",
//                                       fontWeight: 600,
//                                     }}
//                                   >
//                                     {badge.label}
//                                   </span>
//                                 );
//                               })()}
//                             </td>
//                             {/* Actions */}
//                             <td
//                               style={{
//                                 padding: "14px 16px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   gap: "6px",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 {/* 👍 Move back to Follow Up */}
//                                 <Tooltip title="Move to Follow Up">
//                                   <button
//                                     onClick={() =>
//                                       handleMoveToFollowUp(item.id)
//                                     }
//                                     style={{
//                                       width: "32px",
//                                       height: "32px",
//                                       display: "inline-flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                       background: "#f0fdf4",
//                                       color: "#16a34a",
//                                       borderRadius: "8px",
//                                       border: "1px solid #bbf7d0",
//                                       cursor: "pointer",
//                                       transition: "all 0.2s",
//                                       fontSize: "13px",
//                                     }}
//                                   >
//                                     👍
//                                   </button>
//                                 </Tooltip>
//                                 <Tooltip title="Delete">
//                                   <button
//                                     onClick={() => handleDelete(item.id)}
//                                     style={{
//                                       width: "32px",
//                                       height: "32px",
//                                       display: "inline-flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                       background: "#fef2f2",
//                                       color: "#dc2626",
//                                       borderRadius: "8px",
//                                       border: "1px solid #fecaca",
//                                       cursor: "pointer",
//                                       transition: "all 0.2s",
//                                       fontSize: "13px",
//                                     }}
//                                   >
//                                     <DeleteOutlined />
//                                   </button>
//                                 </Tooltip>
//                               </div>
//                             </td>
//                           </tr>
//                         );
//                       })
//                     ) : (
//                       <tr>
//                         <td
//                           colSpan={showCheckboxes ? 10 : 9}
//                           style={{ padding: "60px 20px", textAlign: "center" }}
//                         >
//                           <div style={{ color: "#9ca3af" }}>
//                             <CloseCircleOutlined
//                               style={{
//                                 fontSize: "48px",
//                                 marginBottom: "12px",
//                                 display: "block",
//                               }}
//                             />
//                             <div
//                               style={{
//                                 fontSize: "16px",
//                                 fontWeight: 600,
//                                 color: "#6b7280",
//                               }}
//                             >
//                               No Negative Leads Found
//                             </div>
//                             <div
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#9ca3af",
//                                 marginTop: "4px",
//                               }}
//                             >
//                               Try adjusting your filters
//                             </div>
//                           </div>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               {!isLoading && pageSize > 1 && (
//                 <div
//                   style={{
//                     padding: "16px 24px",
//                     borderTop: "1px solid #f0f0f0",
//                     display: "flex",
//                     justifyContent: "center",
//                     background: "#fffafa",
//                   }}
//                 >
//                   <Pagination
//                     count={pageSize}
//                     page={pageApi}
//                     onChange={(e, v) => setPageApi(v)}
//                     color="primary"
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default NegativeEnquiry;


import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import EnquiryFollowUp from "./EnquiryFollowUp";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import Pagination from "@mui/material/Pagination";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import TableLoader from "../../Loader/TableLoader";
import Swal from "sweetalert2";
import EnquiryModal from "./enquiryModal";

import { Button, Input, Tooltip } from "antd";
import {
  FilterOutlined,
  ClearOutlined,
  SearchOutlined,
  CalendarOutlined,
  EyeOutlined,
  DeleteOutlined,
  CloseCircleOutlined,
  ArrowRightOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import {
  useUpdateEnquiryStatus,
  useFollowUpOptions,
  useInternalUserList,
  useAllocateLeads,
} from "../hooks/useManageEnquiry";
import usePermissions from "../hooks/usePermissions";
import { authHeaders,getSessionToken } from "../utils/session";

const CustomDateInput = React.forwardRef(
  ({ value, onClick, placeholder }, ref) => (
    <div
      onClick={onClick}
      ref={ref}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        cursor: "pointer",
        minHeight: "42px",
        background: "white",
        transition: "all 0.2s",
        width: "100%",
        fontSize: "14px",
        color: value ? "#262626" : "#bfbfbf",
      }}
    >
      <CalendarOutlined
        style={{ color: "#dc2626", fontSize: "14px", flexShrink: 0 }}
      />
      <span style={{ flex: 1 }}>{value || placeholder}</span>
    </div>
  ),
);

const EMPTY_FILTER = { search: "", start_date: "", end_date: "" };

const MODE_NONE = null;
const MODE_DELETE = "delete";
const MODE_ALLOCATE = "allocate";

const NegativeEnquiry = () => {
  const { canDelete } = usePermissions("/cms/manageenquiry/negative-enquiry");

  const [listPageData, setListPageData] = useState([]);
  const [token] = useState(getSessionToken());
  const [isLoading, setIsLoading] = useState(true);
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [statusId, setStatusId] = useState(0);
  const [statusCode, setStatusCode] = useState(0);
  const [modalStatus, setModalStatus] = useState(false);
  const [pageSize, setPageSize] = useState(1);
  const [pageApi, setPageApi] = useState(1);
  const [totalUser, setTotalUser] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isDeleted, setDeleted] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [filterForm, setFilterForm] = useState(EMPTY_FILTER);
  const [appliedFilter, setAppliedFilter] = useState(EMPTY_FILTER);
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  // shared checkbox state
  const [checkboxMode, setCheckboxMode] = useState(MODE_NONE);
  const [selectedIds, setSelectedIds] = useState([]);

  // ── Lead activity panel (same EnquiryFollowUp used by Inbox / Future) ─────
  const [followUpEnquiry, setFollowUpEnquiry] = useState(null);

  useEffect(() => {
    if (!followUpEnquiry) return;
    window.history.pushState({ followUpOpen: true }, "");
    const onPop = () => setFollowUpEnquiry(null);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [followUpEnquiry]);

  const openFollowUp = (item) =>
    setFollowUpEnquiry({
      id: item.id,
      name: item.name,
      service: item.message?.slice(0, 40) || "Enquiry",
      email: item.email,
      phone: item.phone,
      address: item.address,
      company: item.company,
      status:
        item.is_positive == 1 ? "Positive"
        : item.is_positive == 2 ? "Negative"
        : "Neutral",
      assignedTo: item.assign_to_name || "Unassigned",
    });

  // ── Allocate state ────────────────────────────────────────────────────────
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [allocateLoading, setAllocateLoading] = useState(false);
  const [showAllocateModal, setShowAllocateModal] = useState(false);

  const updateStatus = useUpdateEnquiryStatus();
  const searchDebounceRef = useRef(null);
  const { data: followUpOptions = [] } = useFollowUpOptions();
  const { data: internalUsers = [] } = useInternalUserList();
  const allocateLeads = useAllocateLeads();

  const followUpStatusMap = React.useMemo(() => {
    const map = {};
    followUpOptions.forEach((opt) => {
      map[String(opt.option_value)] = opt.label;
    });
    return map;
  }, [followUpOptions]);

  const inDeleteMode = checkboxMode === MODE_DELETE;
  const inAllocateMode = checkboxMode === MODE_ALLOCATE;
  const showCheckboxes = checkboxMode !== MODE_NONE;

  useEffect(() => {
    loadContent();
  }, [pageApi, isDeleted, modalStatus, appliedFilter]);

  const loadContent = async () => {
    setIsLoading(true);
    let param = {
      search: appliedFilter.search,
      start_date: startDate
        ? moment(startDate).utc().add(1, "d").format("YYYY-MM-DD")
        : "",
      end_date: endDate
        ? moment(endDate).utc().add(1, "d").format("YYYY-MM-DD")
        : "",
      /* Ask by board column, not by status. "Negative" is not one status: the
         backend also parks "Not Interested" in this column, and `status: 10`
         asked for the single explicit value — which is why those leads never
         appeared here. The rows are still filtered below, because the API does
         not reliably honour either param; a wide page keeps a freshly closed
         lead from falling off the end of a 10-row page. */
      kanban_column: "negative",
      page: 1,
      limit: 200,
    };
    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-trademark-enquiries`,
        {
          headers: { ...authHeaders() },
          params: param,
        },
      );

      const allData = response.data.data || [];
      const negativeData = allData.filter(
        (item) =>
          /* kanban_column is the backend's own verdict and covers every status
             that closes a lead (Negative, Not Interested, …). The other two are
             fallbacks: 10 = Negative and 5 = Not Interested in
             lead_follow_up_status, and is_positive 2 is the legacy flag older
             rows still carry. */
          String(item.kanban_column || "").trim().toLowerCase() === "negative" ||
          String(item.status) === "10" ||
          String(item.status) === "5" ||
          String(item.is_positive) === "2",
      );

      setListPageData(negativeData);
      setTotalUser(negativeData.length);
      setPageSize(Math.ceil(negativeData.length / 10) || 1);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      setIsFilterLoading(false);
    }
  };

  const followUpStatusStyle = (label) => {
    const l = (label || "").toLowerCase();
    if (l === "follow up")
      return { bg: "#fffbeb", color: "#d97706", border: "#fde68a" };
    if (l === "hot lead")
      return { bg: "#fff7ed", color: "#ea580c", border: "#fed7aa" };
    if (l === "no response")
      return { bg: "#f9fafb", color: "#6b7280", border: "#e5e7eb" };
    if (l === "interested")
      return { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0" };
    if (l === "mark for future")
      return { bg: "#fefce8", color: "#ca8a04", border: "#fef08a" };
    if (l === "not interested")
      return { bg: "#fef2f2", color: "#b91c1c", border: "#fecaca" };
    if (l === "meeting scheduled")
      return { bg: "#eff6ff", color: "#2563eb", border: "#bfdbfe" };
    if (l === "converted")
      return { bg: "#f0fdf4", color: "#16a34a", border: "#bbf7d0" };
    if (l === "not responding")
      return { bg: "#f5f5f5", color: "#9ca3af", border: "#e5e7eb" };
    if (l === "closed")
      return { bg: "#f5f3ff", color: "#7c3aed", border: "#ddd6fe" };
    if (l === "negative")
      return { bg: "#fef2f2", color: "#dc2626", border: "#fecaca" };
    return { bg: "#f9fafb", color: "#6b7280", border: "#e5e7eb" };
  };

  const handleMoveToFollowUp = (id) => {
    Swal.fire({
      title: "Move back to Follow Up?",
      input: "textarea",
      inputLabel: "Remark",
      inputPlaceholder: "Enter your remark...",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Move to Follow Up",
      confirmButtonColor: "#16a34a",
    }).then((r) => {
      if (r.isConfirmed)
        updateStatus.mutate(
          { id, status: 0, remarks: r.value || "" },
          { onSuccess: () => setDeleted((p) => !p) },
        );
    });
  };

  const handleDelete = async (ids) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete the record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            `${API_BASE_URL}/delete-my-trademark-enquiry`,
            JSON.stringify({ id: [ids] }),
            {
              headers: {
                "Content-Type": "application/json",
                ...authHeaders(),
              },
            },
          );
          if (response.data.status === 200) {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            setDeleted((p) => !p);
          }
        } catch {
          Swal.fire("Error", "Failed to delete the file.", "error");
        }
      }
    });
  };

  const handleConfirmDelete = async () => {
    if (selectedIds.length === 0) {
      Swal.fire({
        icon: "error",
        title: "No leads selected",
        text: "Please select at least one lead to delete.",
      });
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: `Delete ${selectedIds.length} selected lead(s)?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            `${API_BASE_URL}/delete-my-trademark-enquiry`,
            JSON.stringify({ id: selectedIds }),
            {
              headers: {
                "Content-Type": "application/json",
                ...authHeaders(),
              },
            },
          );
          if (response.data.status === 200) {
            Swal.fire("Deleted!", "Selected leads deleted.", "success");
            setDeleted((p) => !p);
            resetSelection();
          }
        } catch {
          Swal.fire("Error", "Failed to delete.", "error");
        }
      } else {
        Swal.fire("Cancelled", "Your records are safe.", "info");
      }
    });
  };

  const resetSelection = () => {
    setCheckboxMode(MODE_NONE);
    setSelectedIds([]);
    setSelectAll(false);
    setSelectedAdmin(null);
  };

  const handleSearchChange = (e) => {
    const v = e.target.value;
    setFilterForm((p) => ({ ...p, search: v }));
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      setPageApi(1);
      setAppliedFilter((p) => ({ ...p, search: v }));
    }, 500);
  };

  const applyFilter = () => {
    setPageApi(1);
    setIsFilterLoading(true);
    setAppliedFilter({ ...filterForm });
    loadContent();
  };

  const clearFilter = () => {
    setFilterForm(EMPTY_FILTER);
    setStartDate("");
    setEndDate("");
    setAppliedFilter(EMPTY_FILTER);
    setPageApi(1);
  };

  const handleCheckAll = () => {
    const n = !selectAll;
    setSelectAll(n);
    setSelectedIds(n ? listPageData.map((i) => i.id) : []);
  };

  const handleCheckboxChange = (item) => {
    setSelectedIds((p) =>
      p.includes(item.id) ? p.filter((id) => id !== item.id) : [...p, item.id],
    );
  };

  // ── Allocate ──────────────────────────────────────────────────────────────
  const handleOpenAllocateModal = () => setShowAllocateModal(true);

  const handleAdminSelected = (adminObj) => {
    setSelectedAdmin(adminObj);
    setShowAllocateModal(false);
    setCheckboxMode(MODE_ALLOCATE);
    setSelectedIds([]);
    setSelectAll(false);
  };

  const handleConfirmAllocate = () => {
    if (!selectedAdmin) { toast.error("Please select an admin first."); return; }
    if (selectedIds.length === 0) {
      Swal.fire({ icon: "warning", title: "No leads selected", text: "Please tick at least one lead to allocate.", confirmButtonColor: "#8b5cf6" });
      return;
    }

    const limit = selectedAdmin.lead_limit ?? 0;
    const alreadyHas = selectedAdmin.total_assigned_leads ?? 0;
    const wouldHave = alreadyHas + selectedIds.length;

    if (limit > 0 && wouldHave > limit) {
      const canTake = Math.max(0, limit - alreadyHas);
      Swal.fire({
        icon: "error",
        title: "Lead Limit Exceeded",
        html: `<p><strong>${selectedAdmin.name}</strong> has a lead limit of <strong>${limit}</strong>.</p>
               <p>Currently assigned: <strong>${alreadyHas}</strong> &nbsp;·&nbsp; You're trying to add: <strong>${selectedIds.length}</strong></p>
               <p>Can still accept: <strong style="color:${canTake > 0 ? "#16a34a" : "#dc2626"}">${canTake}</strong> more lead(s).</p>`,
        confirmButtonColor: "#8b5cf6",
      });
      return;
    }

    Swal.fire({
      title: "Confirm Allocation",
      html: `Assign <strong>${selectedIds.length}</strong> lead(s) to <strong>${selectedAdmin.name}</strong>?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Allocate",
      confirmButtonColor: "#8b5cf6",
    }).then((r) => {
      if (!r.isConfirmed) return;
      setAllocateLoading(true);
      allocateLeads.mutate(
        { adminId: selectedAdmin.id, leadIds: selectedIds },
        {
          onSuccess: () => {
            Swal.fire({ icon: "success", title: "Allocated!", text: `${selectedIds.length} lead(s) assigned to ${selectedAdmin.name}.`, confirmButtonColor: "#8b5cf6" });
            resetSelection();
          },
          onError: (err) => Swal.fire("Error", err?.message || "Failed to allocate leads. Please try again.", "error"),
          onSettled: () => setAllocateLoading(false),
        },
      );
    });
  };

  const activeFiltersCount = [filterForm.search, startDate, endDate].filter(Boolean).length;

  const labelStyle = {
    fontWeight: 600,
    color: "#374151",
    fontSize: "13px",
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  };

  const statusBadge = (val) => {
    if (val == 1) return { bg: "#f0fdf4", color: "#16a34a", border: "#bbf7d0", label: "● Positive" };
    if (val == 2) return { bg: "#fef2f2", color: "#dc2626", border: "#fecaca", label: "● Negative" };
    if (val == 0) return { bg: "#eff6ff", color: "#2563eb", border: "#bfdbfe", label: "● Neutral" };
    return { bg: "#fffbeb", color: "#d97706", border: "#fde68a", label: "● Pending" };
  };

  const chkColor = inAllocateMode ? "#8b5cf6" : "#dc2626";

  return (
    <>
      <style>{`
        .custom-datepicker-wrapper{width:100%}.custom-datepicker-wrapper .react-datepicker-wrapper{width:100%}.custom-datepicker-wrapper .react-datepicker__input-container{width:100%}.custom-datepicker-wrapper .react-datepicker-popper{z-index:9999!important}.custom-datepicker-wrapper .react-datepicker{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;border:1px solid #fecaca;border-radius:12px;box-shadow:0 8px 24px rgba(220,38,38,.15);overflow:hidden;font-size:13px}.custom-datepicker-wrapper .react-datepicker__month-container{width:280px}.custom-datepicker-wrapper .react-datepicker__header{background:linear-gradient(135deg,#dc2626 0%,#b91c1c 100%);border-bottom:none;padding:10px 8px 6px;border-radius:0}.custom-datepicker-wrapper .react-datepicker__current-month{color:#fff;font-weight:700;font-size:14px;margin-bottom:4px}.custom-datepicker-wrapper .react-datepicker__day-names{display:flex;justify-content:space-around}.custom-datepicker-wrapper .react-datepicker__day-name{color:rgba(255,255,255,.85);font-weight:600;font-size:11px;width:32px;line-height:32px;margin:1px;text-align:center}.custom-datepicker-wrapper .react-datepicker__month{margin:6px}.custom-datepicker-wrapper .react-datepicker__week{display:flex;justify-content:space-around}.custom-datepicker-wrapper .react-datepicker__day{width:32px;line-height:32px;margin:1px;border-radius:6px;font-size:13px;color:#374151;transition:all .15s;text-align:center}.custom-datepicker-wrapper .react-datepicker__day:hover{background:#fef2f2;color:#dc2626}.custom-datepicker-wrapper .react-datepicker__day--selected,.custom-datepicker-wrapper .react-datepicker__day--keyboard-selected{background:linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)!important;color:#fff!important;font-weight:600}.custom-datepicker-wrapper .react-datepicker__day--today{font-weight:700;color:#dc2626}.custom-datepicker-wrapper .react-datepicker__day--disabled{color:#d1d5db!important}.custom-datepicker-wrapper .react-datepicker__day--outside-month{color:#d1d5db}.custom-datepicker-wrapper .react-datepicker__navigation{top:10px}.custom-datepicker-wrapper .react-datepicker__navigation-icon::before{border-color:rgba(255,255,255,.8);border-width:2px 2px 0 0;height:7px;width:7px}.custom-datepicker-wrapper .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before{border-color:#fff}.custom-datepicker-wrapper .react-datepicker__triangle{display:none}
        @keyframes badgePop{0%{transform:scale(1)}50%{transform:scale(1.2)}100%{transform:scale(1)}}
        .sel-badge{animation:badgePop .25s ease}
        @keyframes meAllocModalIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        .alloc-admin-card{border:2px solid #e5e7eb;border-radius:12px;padding:14px 16px;cursor:pointer;transition:all .18s;background:white}
        .alloc-admin-card:hover{border-color:#8b5cf6;background:#faf5ff;transform:translateY(-1px);box-shadow:0 4px 14px rgba(139,92,246,.15)}
        .alloc-admin-card.selected{border-color:#8b5cf6;background:#faf5ff;box-shadow:0 0 0 3px rgba(139,92,246,.15)}
        .alloc-admin-card.over-limit{border-color:#fca5a5;background:#fef2f2;cursor:not-allowed;opacity:.7}
        .alloc-admin-card.over-limit:hover{transform:none;box-shadow:none}
      `}</style>

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            {/* PAGE HEADER */}
            <div
              style={{
                background: "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)",
                borderRadius: "16px",
                padding: "28px 32px",
                marginBottom: "28px",
                boxShadow: "0 8px 32px rgba(220,38,38,.28)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "16px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <div
                  style={{
                    width: "56px", height: "56px", background: "rgba(255,255,255,.22)",
                    borderRadius: "14px", display: "flex", alignItems: "center",
                    justifyContent: "center", fontSize: "26px", color: "white",
                  }}
                >
                  <CloseCircleOutlined />
                </div>
                <div>
                  <h4 style={{ color: "white", margin: 0, fontSize: "24px", fontWeight: 700 }}>
                    Manage Negative Lead
                  </h4>
                  <p style={{ color: "rgba(255,255,255,.85)", margin: 0, fontSize: "14px" }}>
                    View and manage all negative lead records
                  </p>
                </div>
              </div>
              <div
                style={{
                  background: "rgba(255,255,255,.18)", padding: "10px 18px", borderRadius: "10px",
                  display: "flex", gap: "6px", alignItems: "center", fontSize: "13px", color: "white",
                }}
              >
                <a href="javascript:void(0);" style={{ color: "white", textDecoration: "none" }}>CMS</a>
                <span style={{ color: "rgba(255,255,255,.5)" }}>›</span>
                <span style={{ fontWeight: 600 }}>Manage Negative Lead</span>
              </div>
            </div>

            {/* FILTER CARD */}
            <div
              style={{
                background: "white", borderRadius: "16px", boxShadow: "0 2px 16px rgba(0,0,0,.07)",
                border: "1px solid #f0f0f0", marginBottom: "24px", overflow: "visible",
              }}
            >
              <div
                style={{
                  background: "linear-gradient(135deg,#fff5f5 0%,#fee2e2 100%)",
                  borderBottom: "2px solid #fecaca", padding: "18px 24px",
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div
                    style={{
                      width: "38px", height: "38px", background: "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)",
                      borderRadius: "10px", display: "flex", alignItems: "center",
                      justifyContent: "center", color: "white", fontSize: "16px",
                    }}
                  >
                    <FilterOutlined />
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: "16px", color: "#1f2937" }}>Advanced Filters</div>
                    <div style={{ fontSize: "12px", color: "#6b7280" }}>Narrow down your negative lead search</div>
                  </div>
                </div>
                {activeFiltersCount > 0 && (
                  <span style={{ background: "linear-gradient(135deg,#dc2626,#b91c1c)", color: "white", borderRadius: "20px", padding: "4px 14px", fontSize: "13px", fontWeight: 600 }}>
                    {activeFiltersCount} active
                  </span>
                )}
              </div>
              <div style={{ padding: "24px" }}>
                <div className="row g-3">
                  <div className="col-md-4">
                    <div style={labelStyle}><SearchOutlined style={{ color: "#dc2626" }} /> Name, Email or Mobile</div>
                    <Input
                      size="large" placeholder="Search by name, email or mobile..."
                      value={filterForm.search} onChange={handleSearchChange}
                      prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                      style={{ borderRadius: "8px" }} allowClear
                    />
                  </div>
                  <div className="col-md-4">
                    <div style={labelStyle}><CalendarOutlined style={{ color: "#dc2626" }} /> Start Date</div>
                    <div className="custom-datepicker-wrapper">
                      <DatePicker
                        selected={startDate} onChange={(d) => setStartDate(d)}
                        selectsStart startDate={startDate} endDate={endDate}
                        dateFormat="dd MMM yyyy" placeholderText="Select start date"
                        isClearable={!!startDate}
                        customInput={<CustomDateInput placeholder="Select start date" />}
                        popperPlacement="bottom-start"
                        popperModifiers={[{ name: "preventOverflow", options: { boundary: "viewport" } }, { name: "offset", options: { offset: [0, 4] } }]}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div style={labelStyle}><CalendarOutlined style={{ color: "#dc2626" }} /> End Date</div>
                    <div className="custom-datepicker-wrapper">
                      <DatePicker
                        selected={endDate} onChange={(d) => setEndDate(d)}
                        selectsEnd startDate={startDate} endDate={endDate} minDate={startDate}
                        dateFormat="dd MMM yyyy" placeholderText="Select end date"
                        isClearable={!!endDate}
                        customInput={<CustomDateInput placeholder="Select end date" />}
                        popperPlacement="bottom-start"
                        popperModifiers={[{ name: "preventOverflow", options: { boundary: "viewport" } }, { name: "offset", options: { offset: [0, 4] } }]}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    marginTop: "20px", paddingTop: "20px", borderTop: "1px solid #f0f0f0",
                  }}
                >
                  <Button
                    size="large" icon={<ClearOutlined />} onClick={clearFilter}
                    style={{ borderRadius: "10px", minWidth: "130px", fontWeight: 600, borderColor: "#dc2626", color: "#dc2626", height: "44px" }}
                  >
                    Clear Filters
                  </Button>
                  <Button
                    type="primary" size="large" icon={<FilterOutlined />} onClick={applyFilter} loading={isFilterLoading}
                    style={{ borderRadius: "10px", minWidth: "130px", fontWeight: 600, height: "44px", background: "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)", border: "none", boxShadow: "0 4px 12px rgba(220,38,38,.4)" }}
                  >
                    Apply Filters
                  </Button>
                </div>
              </div>
            </div>

            <EnquiryModal
              token={token} modalIsOpen2={modalIsOpen2} setIsOpen2={setIsOpen2}
              id={statusId} setStatusId={setStatusId} statusCode={statusCode}
              setStatusCode={setStatusCode} setModalStatus={setModalStatus} modalStatus={modalStatus}
            />

            {/* TABLE CARD */}
            <div
              style={{
                background: "white", borderRadius: "16px", boxShadow: "0 2px 16px rgba(0,0,0,.07)",
                border: "1px solid #f0f0f0", overflow: "hidden",
              }}
            >
              {/* Action bar */}
              <div
                style={{
                  padding: "20px 24px", borderBottom: "2px solid #f5f5f5",
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  flexWrap: "wrap", gap: "12px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                  <div
                    style={{
                      width: "38px", height: "38px", background: "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)",
                      borderRadius: "10px", display: "flex", alignItems: "center",
                      justifyContent: "center", color: "white", fontSize: "16px",
                    }}
                  >
                    <CloseCircleOutlined />
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: "17px", color: "#1f2937" }}>Negative Lead List</div>
                    <div style={{ fontSize: "12px", color: "#6b7280" }}>{totalUser} total {totalUser === 1 ? "record" : "records"}</div>
                  </div>
                  <span style={{ background: "#fef2f2", color: "#dc2626", borderRadius: "20px", padding: "3px 12px", fontSize: "13px", fontWeight: 700 }}>
                    {totalUser}
                  </span>
                  {showCheckboxes && selectedIds.length > 0 && (
                    <span
                      key={selectedIds.length}
                      className="sel-badge"
                      style={{
                        background: inAllocateMode ? "linear-gradient(135deg,#8b5cf6,#7c3aed)" : "linear-gradient(135deg,#ef4444,#dc2626)",
                        color: "white", borderRadius: "20px", padding: "3px 12px", fontSize: "13px", fontWeight: 700,
                      }}
                    >
                      {selectedIds.length} selected
                    </span>
                  )}
                  {/* Admin chip when in allocate mode */}
                  {inAllocateMode && selectedAdmin && (
                    <span
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "6px",
                        background: "#faf5ff", border: "1.5px solid #c4b5fd", borderRadius: "20px",
                        padding: "3px 12px", fontSize: "12px", fontWeight: 600, color: "#7c3aed",
                      }}
                    >
                      <TeamOutlined /> {selectedAdmin.name}
                      <span style={{ background: "#ede9fe", borderRadius: "10px", padding: "1px 7px", fontSize: "11px" }}>
                        Assigned: {selectedAdmin.total_assigned_leads ?? 0} / Limit: {selectedAdmin.lead_limit}
                      </span>
                    </span>
                  )}
                </div>
                <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                  {/* Delete Selected */}
                  {canDelete && (<>
                  {inDeleteMode && (
                    <button
                      onClick={resetSelection}
                      style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "white", color: "#6b7280", borderRadius: "10px", padding: "8px 18px", fontWeight: 600, fontSize: "14px", border: "2px solid #e0e0e0", cursor: "pointer" }}
                    >
                      ✕ Cancel
                    </button>
                  )}
                  <button
                    onClick={() => {
                      if (checkboxMode !== MODE_DELETE) { setCheckboxMode(MODE_DELETE); setSelectedIds([]); setSelectAll(false); setSelectedAdmin(null); return; }
                      handleConfirmDelete();
                    }}
                    style={{
                      display: "inline-flex", alignItems: "center", gap: "6px",
                      background: "linear-gradient(135deg,#ef4444 0%,#dc2626 100%)",
                      color: "white", borderRadius: "10px", padding: "8px 18px", fontWeight: 600,
                      fontSize: "14px", border: "none", cursor: "pointer",
                      boxShadow: "0 4px 12px rgba(239,68,68,.3)",
                      outline: inDeleteMode ? "2px solid #dc2626" : "none",
                      outlineOffset: "2px", transition: "all 0.2s",
                    }}
                  >
                    <DeleteOutlined /> {inDeleteMode ? "Confirm Delete" : "Delete Selected"}
                  </button>
                  </>)}

                  {/* Allocate */}
                  {inAllocateMode && (
                    <button
                      onClick={resetSelection}
                      style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "white", color: "#6b7280", borderRadius: "10px", padding: "8px 18px", fontWeight: 600, fontSize: "14px", border: "2px solid #e0e0e0", cursor: "pointer" }}
                    >
                      ✕ Cancel
                    </button>
                  )}
                  <button
                    onClick={inAllocateMode ? handleConfirmAllocate : handleOpenAllocateModal}
                    disabled={allocateLeads.isPending || allocateLoading}
                    style={{
                      display: "inline-flex", alignItems: "center", gap: "6px",
                      background: "linear-gradient(135deg,#8b5cf6 0%,#7c3aed 100%)",
                      color: "white", borderRadius: "10px", padding: "8px 18px", fontWeight: 600,
                      fontSize: "14px", border: "none", cursor: "pointer",
                      boxShadow: inAllocateMode ? "0 4px 14px rgba(139,92,246,.45)" : "0 4px 12px rgba(139,92,246,.3)",
                      outline: inAllocateMode ? "2px solid #7c3aed" : "none",
                      outlineOffset: "2px", transition: "all 0.2s",
                    }}
                  >
                    {allocateLoading ? (
                      <span className="spinner-border spinner-border-sm text-white" />
                    ) : (
                      <><TeamOutlined /> {inAllocateMode ? "Confirm Allocate" : "Allocate"}</>
                    )}
                  </button>
                </div>
              </div>

              {/* ── Helper instruction bar ── */}
              {showCheckboxes && (
                <div
                  style={{
                    padding: "10px 24px",
                    background: inAllocateMode ? "linear-gradient(135deg,#f5f3ff,#ede9fe)" : "linear-gradient(135deg,#fef2f2,#fee2e2)",
                    borderBottom: `2px solid ${inAllocateMode ? "#c4b5fd" : "#fecaca"}`,
                    display: "flex", alignItems: "center", gap: "10px", fontSize: "13px",
                    color: inAllocateMode ? "#7c3aed" : "#dc2626",
                  }}
                >
                  {inAllocateMode ? (
                    <><TeamOutlined /> <strong>Allocate mode:</strong>&nbsp;Tick leads to assign to <strong>{selectedAdmin?.name}</strong>, then click <strong>Confirm Allocate</strong>.</>
                  ) : (
                    <><DeleteOutlined /> <strong>Delete mode:</strong>&nbsp;Tick leads to delete, then click <strong>Confirm Delete</strong>.</>
                  )}
                  <span style={{ marginLeft: "auto", fontWeight: 700 }}>
                    {selectedIds.length} / {listPageData.length} selected on this page
                  </span>
                </div>
              )}

              {/* Table */}
              <div className="table-responsive">
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr
                      style={{
                        background: "linear-gradient(135deg,#fff5f5 0%,#fee2e2 100%)",
                        borderBottom: "2px solid #fecaca",
                      }}
                    >
                      {showCheckboxes && (
                        <th style={{ padding: "14px 16px", textAlign: "center" }}>
                          <input
                            className="form-check-input" type="checkbox"
                            checked={selectAll} onChange={handleCheckAll}
                            style={{ accentColor: chkColor }}
                          />
                        </th>
                      )}
                      {["Name", "Email", "Mobile",
                      // "UTM Sources", "Sources",
                       "Message", "Date","Status", "Actions"].map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: "14px 16px", textAlign: "center", fontSize: "12px",
                            fontWeight: 700, color: "#dc2626", textTransform: "uppercase",
                            letterSpacing: "0.6px", whiteSpace: "nowrap",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <TableLoader />
                    ) : listPageData.length > 0 ? (
                      listPageData.map((item, idx) => {
                        const isSel = selectedIds.includes(item.id);
                        const rowBg = isSel
                          ? inAllocateMode ? "#f5f3ff" : "#fef2f2"
                          : idx % 2 === 0 ? "white" : "#fffafa";
                        return (
                          <tr
                            key={item.id}
                            // Row click opens the lead's activity panel, same as Inbox / Future
                            onClick={() => { if (!showCheckboxes) openFollowUp(item); }}
                            style={{ borderBottom: "1px solid #f5f5f5", transition: "background 0.15s", background: rowBg, cursor: showCheckboxes ? "default" : "pointer" }}
                            onMouseEnter={(e) => { if (!isSel) e.currentTarget.style.background = "#fff5f5"; }}
                            onMouseLeave={(e) => { if (!isSel) e.currentTarget.style.background = rowBg; }}
                          >
                            {showCheckboxes && (
                              <td style={{ padding: "14px 16px", textAlign: "center" }}>
                                <input
                                  type="checkbox" checked={isSel}
                                  onChange={() => handleCheckboxChange(item)}
                                  style={{ accentColor: chkColor, width: "15px", height: "15px" }}
                                />
                              </td>
                            )}
                            {/* Name */}
                            <td style={{ padding: "14px 16px", textAlign: "left" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <div
                                  style={{
                                    width: "34px", height: "34px", borderRadius: "50%",
                                    background: "linear-gradient(135deg,#dc2626,#b91c1c)",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    color: "white", fontSize: "13px", fontWeight: 700, flexShrink: 0,
                                  }}
                                >
                                  {item.name?.split(" ").map((w) => w.charAt(0)).join("").slice(0, 2).toUpperCase() || "?"}
                                </div>
                                <span style={{ fontWeight: 600, color: "#1f2937", fontSize: "14px" }}>{item?.name}</span>
                              </div>
                            </td>
                            {/* Email */}
                            <td style={{ padding: "14px 16px", fontSize: "13px", color: "#4b5563",  minWidth: "180px", whiteSpace: "nowrap" }}>
                              {item?.email ? (
                                <span style={{ background: "#eff6ff", color: "#2563eb", borderRadius: "4px", padding: "2px 8px", fontSize: "12px", display: "inline-block", whiteSpace: "nowrap", }}>{item.email}</span>
                              ) : (
                                <span style={{ color: "#9ca3af", fontSize: "12px" }}>N/A</span>
                              )}
                            </td>
                            {/* Mobile */}
                            <td style={{ padding: "14px 16px", fontSize: "13px", color: "#4b5563", whiteSpace: "nowrap" }}>
                              {item?.phone ? (
                                <span style={{ fontWeight: 500, color: "#374151" }}>{withCountryCode(item.country_code, item.phone)}</span>
                              ) : (
                                <span style={{ color: "#9ca3af", fontSize: "12px" }}>N/A</span>
                              )}
                              {/* Alternate number, only when present */}
                              <AdditionalPhones
                                value={item?.additional_phone}
                                dot
                                max={2}
                                style={{ marginTop: "3px" }}
                                itemStyle={{ fontWeight: 500, fontSize: "12px" }}
                              />
                            </td>
                            {/* UTM */}
                            {/* <td style={{ padding: "14px 16px", fontSize: "13px", color: "#4b5563" }}>
                              <div style={{ marginBottom: "2px" }}><span style={{ color: "#9ca3af", fontSize: "12px" }}>Source: </span>{item?.utm_source || "N/A"}</div>
                              <div style={{ marginBottom: "2px" }}><span style={{ color: "#9ca3af", fontSize: "12px" }}>Medium: </span>{item?.utm_medium || "N/A"}</div>
                              <div><span style={{ color: "#9ca3af", fontSize: "12px" }}>Campaign: </span>{item?.utm_campaign ? item.utm_campaign.substring(0, 10) + "..." : "N/A"}</div>
                            </td> */}
                            {/* Sources */}
                            {/* <td style={{ padding: "14px 16px", fontSize: "13px", color: "#4b5563" }}>
                              <div style={{ marginBottom: "2px" }}>
                                <span style={{ color: "#9ca3af", fontSize: "12px" }}>IP: </span>
                                {item.system_ip ? (
                                  <a href={`https://ip-api.com/#${item.system_ip}`} target="_blank" rel="noreferrer" style={{ color: "#dc2626" }}>{item.system_ip}</a>
                                ) : "N/A"}
                              </div>
                              <div>
                                <span style={{ color: "#9ca3af", fontSize: "12px" }}>URL: </span>
                                {item.source_url ? (
                                  <a href={item.source_url} target="_blank" rel="noreferrer">
                                    <span style={{ background: "#fef2f2", color: "#dc2626", borderRadius: "4px", padding: "1px 6px", fontSize: "12px" }}>Click Here</span>
                                  </a>
                                ) : "N/A"}
                              </div>
                            </td> */}
                            {/* Message */}
                            <td style={{ padding: "14px 16px", fontSize: "13px", color: "#4b5563", textAlign: "center" }}>
                              {item.message ? item.message.substring(0, 10) + "..." : "N/A"}
                            </td>
                            {/* Date */}
                            <td style={{ padding: "14px 16px", fontSize: "13px", color: "#4b5563", whiteSpace: "nowrap", textAlign: "center" }}>
                              {item.created_date || moment(item.created_at).format("DD MMM YYYY")}
                            </td>
                             {/* Status */}
                            <td style={{ padding: "14px 16px", textAlign: "center",  minWidth: "140px", whiteSpace: "nowrap", }}>
                              {(() => {
                                const fuLabel = item.status != null ? followUpStatusMap[String(item.status)] : null;
                                if (fuLabel) {
                                  const style = followUpStatusStyle(fuLabel);
                                  return (
                                    <span style={{ background: style.bg, color: style.color, border: `1px solid ${style.border}`, borderRadius: "20px", padding: "3px 12px", fontSize: "12px", fontWeight: 600, whiteSpace: "nowrap", display: "inline-block", }}>
                                      ● {fuLabel}
                                    </span>
                                  );
                                }
                                const badge = statusBadge(item.is_positive);
                                return (
                                  <span style={{ background: badge.bg, color: badge.color, border: `1px solid ${badge.border}`, borderRadius: "20px", padding: "3px 12px", fontSize: "12px", fontWeight: 600, whiteSpace: "nowrap", display: "inline-block", }}>
                                    {badge.label}
                                  </span>
                                );
                              })()}
                            </td>
                            {/* Actions */}
                            <td style={{ padding: "14px 16px", textAlign: "center" }}>
                              <div style={{ display: "flex", gap: "6px", alignItems: "center", justifyContent: "center" }}>
                                <Tooltip title="Move to Follow Up">
                                  <button
                                    onClick={(e) => { e.stopPropagation(); handleMoveToFollowUp(item.id); }}
                                    style={{ width: "32px", height: "32px", display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#f0fdf4", color: "#16a34a", borderRadius: "8px", border: "1px solid #bbf7d0", cursor: "pointer", transition: "all 0.2s", fontSize: "13px" }}
                                  >
                                    👍
                                  </button>
                                </Tooltip>
                                {canDelete && (
                                <Tooltip title="Delete">
                                  <button
                                    onClick={() => handleDelete(item.id)}
                                    style={{ width: "32px", height: "32px", display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#fef2f2", color: "#dc2626", borderRadius: "8px", border: "1px solid #fecaca", cursor: "pointer", transition: "all 0.2s", fontSize: "13px" }}
                                  >
                                    <DeleteOutlined />
                                  </button>
                                </Tooltip>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={showCheckboxes ? 10 : 9} style={{ padding: "60px 20px", textAlign: "center" }}>
                          <div style={{ color: "#9ca3af" }}>
                            <CloseCircleOutlined style={{ fontSize: "48px", marginBottom: "12px", display: "block" }} />
                            <div style={{ fontSize: "16px", fontWeight: 600, color: "#6b7280" }}>No Negative Leads Found</div>
                            <div style={{ fontSize: "13px", color: "#9ca3af", marginTop: "4px" }}>Try adjusting your filters</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          ALLOCATE MODAL — Select Internal User + lead_limit check
      ══════════════════════════════════════════════════════════════════════ */}
      {showAllocateModal && (
        <div
          style={{ position: "fixed", inset: 0, zIndex: 1200, background: "rgba(15,23,42,.55)", backdropFilter: "blur(5px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowAllocateModal(false); }}
        >
          <div
            style={{ background: "white", borderRadius: "18px", width: "100%", maxWidth: "580px", overflow: "hidden", boxShadow: "0 20px 60px rgba(139,92,246,.25)", animation: "meAllocModalIn .28s ease", border: "2px solid #ede9fe" }}
          >
            {/* Header */}
            <div style={{ background: "linear-gradient(135deg,#8b5cf6,#7c3aed)", padding: "16px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div style={{ width: "34px", height: "34px", background: "rgba(255,255,255,.2)", borderRadius: "9px", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "16px" }}>
                  <TeamOutlined />
                </div>
                <div>
                  <div style={{ color: "white", fontWeight: 700, fontSize: "15px" }}>Allocate Leads</div>
                  <div style={{ color: "rgba(255,255,255,.75)", fontSize: "11px" }}>Select an internal user to assign leads to</div>
                </div>
              </div>
              <button
                onClick={() => setShowAllocateModal(false)}
                style={{ width: "28px", height: "28px", borderRadius: "50%", background: "rgba(255,255,255,.2)", border: "none", color: "white", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
              </button>
            </div>

            {/* User list */}
            <div style={{ padding: "20px 22px", maxHeight: "60vh", overflowY: "auto" }}>
              {internalUsers.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: "#9ca3af" }}>
                  <TeamOutlined style={{ fontSize: "40px", marginBottom: "10px", display: "block" }} />
                  <div>No internal users found</div>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {internalUsers.map((user) => {
                    const used = user.total_assigned_leads ?? 0;
                    const limit = user.lead_limit ?? 0;
                    const pct = limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;
                    const overLimit = limit > 0 && used >= limit;
                    return (
                      <div
                        key={user.id}
                        className={`alloc-admin-card${overLimit ? " over-limit" : ""}`}
                        onClick={() => { if (!overLimit) handleAdminSelected(user); }}
                        title={overLimit ? `${user.name} has reached their lead limit (${limit})` : ""}
                      >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div style={{ width: "36px", height: "36px", borderRadius: "50%", background: "linear-gradient(135deg,#8b5cf6,#7c3aed)", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "13px", fontWeight: 700, flexShrink: 0 }}>
                              {user.name?.split(" ").map((w) => w.charAt(0)).join("").slice(0, 2).toUpperCase() || "?"}
                            </div>
                            <div>
                              <div style={{ fontWeight: 700, fontSize: "14px", color: "#1f2937" }}>{user.name}</div>
                              <div style={{ fontSize: "12px", color: "#6b7280" }}>{user.email}</div>
                            </div>
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <span style={{ background: overLimit ? "#fef2f2" : "#f5f3ff", color: overLimit ? "#dc2626" : "#7c3aed", border: `1px solid ${overLimit ? "#fecaca" : "#ddd6fe"}`, borderRadius: "20px", padding: "3px 10px", fontSize: "12px", fontWeight: 700 }}>
                              {used} / {limit} leads
                            </span>
                            {overLimit && <div style={{ fontSize: "11px", color: "#dc2626", marginTop: "3px", fontWeight: 600 }}>Limit reached</div>}
                          </div>
                        </div>
                        {/* Progress bar */}
                        <div style={{ background: "#f3f4f6", borderRadius: "99px", height: "6px", overflow: "hidden" }}>
                          <div
                            style={{
                              height: "100%", borderRadius: "99px", width: `${pct}%`,
                              background: pct >= 100 ? "linear-gradient(90deg,#ef4444,#dc2626)" : pct >= 80 ? "linear-gradient(90deg,#f59e0b,#d97706)" : "linear-gradient(90deg,#8b5cf6,#7c3aed)",
                              transition: "width .4s ease",
                            }}
                          />
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "4px", fontSize: "11px", color: "#9ca3af" }}>
                          <span>Role: <strong>{user.role}</strong></span>
                          <span>{pct}% used &nbsp;·&nbsp; {Math.max(0, limit - used)} remaining</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div style={{ padding: "14px 22px", borderTop: "1px solid #f0f0f0", background: "#fafafa", display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => setShowAllocateModal(false)}
                style={{ padding: "8px 22px", background: "#f1f5f9", color: "#6b7280", border: "1.5px solid #e2e8f0", borderRadius: "10px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Lead activity panel — full-screen overlay above the app chrome,
             same wrapper Inbox / All Leads / Future use. ── */}
      {followUpEnquiry && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1050, background: "#f1f5f9", animation: "slideInRight .28s ease" }}>
          <EnquiryFollowUp
            enquiry={followUpEnquiry}
            onClose={() => setFollowUpEnquiry(null)}
          />
        </div>
      )}
    </>
  );
};

export default NegativeEnquiry;

